import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { Snackbar } from '@mui/material'
import SnackbarContent from '@mui/material/SnackbarContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { Theme } from '@mui/material/styles'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    ultimate?: { main: string; contrastText: string }
  }
}

const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => {
  const t = theme as MikeTheme
  return {
    backgroundColor: t.palette.ultimate?.main,
    color: t.palette.ultimate?.contrastText
  }
})

const AppNotificationSnack = ({ open, message, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      open={open}
    >
      <StyledSnackbarContent
        message={message}
        action={
          onClose ? (
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ) : (
            undefined
          )
        }
      />
    </Snackbar>
  )
}
AppNotificationSnack.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func
}

export default AppNotificationSnack
